import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    lang: 'es',
    session: JSON.parse(localStorage.getItem('HISPANO@session')) || null,
    alert: {
      open: false,
      message: 'Error',
      variant: 'danger',
      color_text: 'white',
      timeout: 0,
    },
    loading: {
      show: false,
      title: 'Cargando',
      subtitle: 'un momento...'
    },
  },
  getters: {
    getLang: state => {
      return state.lang;
    },
    getSession: state => {
      return state.session;
    },
    getAlert: (state) => {
      return state.alert
    },
    getLoad: (state) => {
      return state.loading
    }
  },
  mutations: {
    setLang: (state, new_lang) => {
      localStorage.setItem('HISPANO@language', JSON.stringify(new_lang))
      state.lang = new_lang
    },

    setSession: (state, new_data) => {
      state.session = new_data // Actualiza el estado
      localStorage.setItem('HISPANO@session', JSON.stringify(new_data)) // Actualiza localStorage
    },

    setDataSession: (state, new_data) => {
      if (state.session) {
        state.session.data = new_data // Actualiza el estado
        localStorage.setItem('HISPANO@session', JSON.stringify(state.session)) // Actualiza localStorage
      }
    },

    setReferencePaymentData: (state, new_data) => {
      if (state.session) {
        state.session.payment_data = new_data
        localStorage.setItem('HISPANO@session', JSON.stringify(state.session))
      }
    },

    setAuthorizationID: (state, new_authorization_id) => {
      if (state.session) {
        state.session.authorization_id = new_authorization_id
        localStorage.setItem('HISPANO@session', JSON.stringify(state.session))
      }
    },

    setAlert: (state, new_alert) => {
      const {
        open = false,
        message = '',
        variant = 'success',
        color_text = 'white',
        timeout = 2000
      } = new_alert;

      // Limpia el temporizador anterior si existe
      if (state.alert._timer) {
        clearTimeout(state.alert._timer);
        state.alert._timer = null;
      }

      // Actualiza el estado del alert
      state.alert = { open, message, variant, color_text, timeout };

      // Configura un nuevo temporizador si `open` es true
      if (open && timeout !== null) {
        state.alert._timer = setTimeout(() => {
          state.alert.open = false;
        }, timeout);
      }
    },

    setLoad: (state, new_load) => {
      state.loading.show = new_load.show
      state.loading.title = (new_load.title !== undefined) ? new_load.title : ''
      state.loading.subtitle = (new_load.subtitle !== undefined) ? new_load.subtitle : ''
      state.loading.timeout = (new_load.timeout !== undefined) ? new_load.timeout : 200000

      if (state.loading.timeout !== null) {
        setTimeout(() => {
          state.loading.show = false
        }, state.loading.timeout)
      }
    }
  },
  actions: {
    changeLang: ({commit}, language) => {
      //console.log(language, 'language')
      commit('setLang', language)
    },
    getLang: () => {
      //console.log(localStorage.getItem('HISPANO@language'))
      return localStorage.getItem('HISPANO@language')
    },
    createSession: ({commit}, session_data) => {
      //console.log(session_data, 'session_data')
      commit('setSession', session_data)
    },
    existSession: () => {
      //console.log(localStorage.getItem('HISPANO@session'))
      return localStorage.getItem('HISPANO@session')
    },
    sessionPABS: () => {
      //console.log(localStorage.getItem('HISPANO@session'))
      return localStorage.getItem('SISTEMAS@PABS')
    },
    deleteSession: () => {
      //console.log(localStorage.getItem('HISPANO@session'))
      localStorage.removeItem('HISPANO@session')
    },
    updateSession: ({commit}, session_data) => {
      // console.log(session_data, 'updateSession')
      commit('setDataSession', session_data)
    },
    updateReferencePaymentData: ({commit}, reference_payment_data) => {
      console.log(reference_payment_data, 'setReferencePaymentData')
      commit('setReferencePaymentData', reference_payment_data)
    },
    saveAuthorizationID: ({commit}, authorization_id) => {
      console.log('guarda authorization_id', authorization_id)
      commit('setAuthorizationID', authorization_id)
    }
  },
  modules: {}
})
